import styled from "styled-components";

/**
 * Externalized styles for {@link ./SponsorOptionsPanel} (kitecorp/transferify-ui#1868).
 *
 * The panel itself is not a surface: it renders inside whatever box the feature around it already
 * draws, so nothing here paints a background or a border. The sponsor form puts it in its own `Panel`;
 * the sender's page-theme sheet (kitecorp/transferify-ui#1869) will put it in a sheet section.
 */

export const OptionsHead = styled.div`
	margin-bottom: 16px;
`;

export const OptionsTitle = styled.h3`
	margin: 0;
	font-size: 16px;
	font-weight: 700;
	letter-spacing: -0.01em;
	color: ${({theme}) => theme.tokens.ink};
`;

export const OptionsLede = styled.p`
	margin: 6px 0 0;
	max-width: 620px;
	font-size: 13px;
	line-height: 1.55;
	color: ${({theme}) => theme.tokens.ink2};
`;

/**
 * The controls, in as many columns as the container can give them.
 *
 * `auto-fit` against a container-relative floor rather than a media query, so the panel reflows to one
 * column inside a narrow sheet on a wide screen — which is exactly where the sender's page-theme picker
 * mounts it — and not only on a narrow viewport. The floor is the width of the placement grid plus its
 * label, below which a two-column row would put the 3x3 grid in a track it overflows.
 */
export const OptionsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr));
	gap: 22px 24px;
	align-items: start;
`;
